module.exports = __webpack_public_path__ + "img/defaultstudent.30450766.png";